import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables/index';
import React from 'react';
import styled from 'styled-components';

import ArrowRightPath from '../../media/arrow_right.svg';
import {pxToEm} from '../globalStyles';
import HexagonIconImage, {HexagonBaseBg, HexagonSize} from '../hexagonIconImage';

//#region Styled Components

const ARROW_RIGHT_WRAPPER_SIZE_PX = 30;

export const StyledWrapper = styled.div<{
  direction: Direction;
  hexagonSize: number;
  hexagonOverflowPx: number;
  borderRadius: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: ${props => props.borderRadius};
  box-shadow: 0 0 5px rgba(51, 133, 227, 0.22);

  margin-top: ${props => pxToEm(props.hexagonOverflowPx)}em;
  margin-right: ${pxToEm(ARROW_RIGHT_WRAPPER_SIZE_PX / 2)}em;
  margin-bottom: ${props => pxToEm(props.hexagonOverflowPx)}em;
  margin-left: ${props => pxToEm(props.hexagonSize / 2)}em;
`;

export const StyledContent = styled.div<{
  direction: Direction;
  hexagonSize: number;
  hexagonOverflowPx: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  margin-left: ${props => (props.direction === Direction.Right ? pxToEm(props.hexagonSize / 2) : pxToEm(31))}em;
  margin-right: ${props =>
    props.direction === Direction.Right
      ? pxToEm(ARROW_RIGHT_WRAPPER_SIZE_PX / 2 + 10)
      : pxToEm(props.hexagonSize / 2)}em;
  height: ${props => pxToEm(props.hexagonSize - props.hexagonOverflowPx * 2)}em;
`;

export const StyledHexagonIconImage = styled(HexagonIconImage)<{direction: Direction}>`
  position: absolute;
  left: ${props => (props.direction === Direction.Right ? '0' : 'auto')};
  right: ${props => (props.direction === Direction.Left ? '0' : 'auto')};
  transform: translateX(${props => (props.direction === Direction.Right ? '-50%' : '50%')});
`;

export const StyledRightArrowImgWrapper = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(${pxToEm(ARROW_RIGHT_WRAPPER_SIZE_PX / 2)}em);
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${pxToEm(ARROW_RIGHT_WRAPPER_SIZE_PX)}em;
  height: ${pxToEm(ARROW_RIGHT_WRAPPER_SIZE_PX)}em;
  background-color: white;
  box-shadow: 0 0 5px rgba(51, 133, 227, 0.22);
  border-radius: 50%;
`;

//#endregion

export enum Direction {
  Left,
  Right
}

export interface Props {
  hexagonIconSrc: string;
  direction?: Direction;
  hexagonSize?: HexagonSize;
  hexagonOverflowPx?: number;
  borderRadius?: string;
  baseBg?: HexagonBaseBg;
}

const HexagonLeaflet: React.FunctionComponent<Props> = ({
  hexagonIconSrc,
  direction = Direction.Right,
  hexagonSize = HexagonSize.Normal,
  hexagonOverflowPx = 14,
  borderRadius = baseVariables.sizes.borderRadius,
  baseBg,
  children
}) => {
  return (
    <StyledWrapper
      direction={direction}
      hexagonSize={hexagonSize}
      hexagonOverflowPx={hexagonOverflowPx}
      borderRadius={borderRadius}>
      <StyledContent direction={direction} hexagonSize={hexagonSize} hexagonOverflowPx={hexagonOverflowPx}>
        {children}
      </StyledContent>

      <StyledHexagonIconImage
        direction={direction}
        size={hexagonSize}
        iconSrc={hexagonIconSrc}
        baseBg={baseBg != undefined ? baseBg : HexagonBaseBg.BlueOrange}
      />

      {direction === Direction.Right && (
        <StyledRightArrowImgWrapper>
          <img src={ArrowRightPath} alt="Arrow Right" />
        </StyledRightArrowImgWrapper>
      )}
    </StyledWrapper>
  );
};

export default HexagonLeaflet;
